import React from 'react';

import { WIZARD_STEP_VALUES } from './common-util/resources';
import { withWizardContext } from './contexts/WizardContext';
import DuplicateRecordsStep from './DuplicateRecordsStep';
import HeaderMappingStep from './HeaderMappingStep';
import PreviewStep from './PreviewStep';
import SelectSheetStep from './SelectSheetStep';
import { WizardContentProps } from './WizardContentProps';

function WizardContent(props: WizardContentProps) {
    let step = null;
    switch (props.currentStep) {
        case WIZARD_STEP_VALUES.SELECT_SHEET:
            step = <SelectSheetStep {...props} />;
            break;
        case WIZARD_STEP_VALUES.HEADER_MAPPING:
            step = <HeaderMappingStep {...props} />;
            break;
        case WIZARD_STEP_VALUES.DUPLICATE_RECORDS:
            step = <DuplicateRecordsStep {...props} />;
            break;
        case WIZARD_STEP_VALUES.PREVIEW:
            step = <PreviewStep {...props} />;
            break;
    }
    return <div>{step}</div>;
}

export default withWizardContext(WizardContent);
